import { AdmService } from '../../../shared/services/adm.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ClasePorEstado, isMobile, isMobileXL, loadData, scrollToInvalidFromControls } from 'src/app/shared/utils/helpers';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { DataClientePedidos } from 'src/app/shared/models/dataClientePedidos';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, startWith, switchMap, tap } from 'rxjs';
import { Direccion } from 'src/app/shared/models/direccion';
import { Division } from 'src/app/shared/models/division';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GrupoCliente } from 'src/app/shared/models/grupoCliente';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Moneda } from 'src/app/shared/models/moneda';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { PedidoVentaItem } from 'src/app/shared/models/pedidoVentaItem';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { Region } from 'src/app/shared/models/region';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Stock } from 'src/app/shared/models/stock';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { MatTableDataSource } from '@angular/material/table';
import { PedidoVentaItemDescuento } from 'src/app/shared/models/pedidoVentaItemDescuento';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { PedidoCabecera } from 'src/app/shared/models/pedidoCabecera';
import { NCService } from 'src/app/shared/services/nc.service';
import { NotaCreditoCabecera } from 'src/app/shared/models/notaCreditoCabecera';


@Component({
  selector: 'app-nc-pedidos-relacionados-dialog',
  templateUrl: './nc-pedidos-relacionados-dialog.component.html'
})
export class NCPedidosRelacionadosDialogComponent {

  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;
  displayedColumns = ['acciones', 'tipoOrden', 'nroPedido', 'nroOrdenSAP', 'estado', 'terminoPago', 'idZonaVendedor', 'nombreDistribuidor', 'total', 'totalLocal', 'fechaCreacion'];
  dataSource = new MatTableDataSource<PedidoCabecera>();

  ncCab: NotaCreditoCabecera;

  constructor(
    private admService: AdmService,
    private cd: ChangeDetectorRef,
    private configService: ConfigService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private parametrosService: ParametrosService,
    private productosService: ProductosService,
    private ncService: NCService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private activatedRoute: ActivatedRoute,
    private dialogRef: MatDialogRef<NCPedidosRelacionadosDialogComponent>,
    private usuarioService: UsuariosService,
    @Inject(MAT_DIALOG_DATA) private data: any

  ) {
    if (data.cab != null) {
      this.ncCab = data.cab;
    }
  }


  public Etiquetas: {

    Acciones: string,
    Buscar: string,
    CalleNroDireccionEntrega: string,
    Cantidad: string,
    CantidadDisponible: string,
    CiudadDireccionEntrega: string,
    Cliente: string,
    Comentario: string,
    Compania: string,
    CPDireccionEntrega: string,
    CuentaDistribuidor: string,
    CuitCliente: string,
    DescuentoDiscrecional: string,
    Direccion: string,
    DireccionEntrega: string,
    Division: string,
    Estado: string,
    FechaCreacion: string
    FechaDesde: string,
    FechaEstado: string,
    FechaHasta: string,
    Glosa: string,
    IdGrupoCliente: string,
    IdMoneda: string,
    IdProducto: string,
    IdTaxClassification: string,
    IdTipoListaPrecios: string,
    Item: string,
    MensajeIntegracion: string,
    MotivoRetencion: string,
    NombreCliente: string,
    NombreClienteDireccionEntrega: string,
    NombreDistribuidor: string,
    NroCliente: string
    NroClienteDireccionEntrega: string,
    NroOrdenSAP: string
    NroPedido: string;
    Path: string
    PrecioUnitarioLista: string,
    Producto: string,
    Region: string,
    SalesOrg: string
    SinRegistros: string
    TerminoPago: string,
    TipoEntrega: string,
    TipoListaPrecios: string,
    TipoOrden: string,
    Titulo: string
    Total: string,
    TotalLocal: string,
    ZonaVendedor: string
    PrecioUnitarioFinal: string,
    DescripcionItemDescuento: string,
    PrecioKGL: string,
    IdTipoCondicion: string,
    Importe: string,
    Porcentaje: string,
    DescuentoCategoria: string,
    TotalPrecioKGL: string,
    NroLinea: string,
    TotalDescuento: string,
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }

  ngOnInit() {
    this.Etiquetas = {

      Acciones: this.configService.etiquetas.Acciones,

      Buscar: this.configService.etiquetas.Buscar,
      CalleNroDireccionEntrega: this.configService.etiquetas.CalleNroDireccionEntrega,
      Cantidad: this.configService.etiquetas.Cantidad,
      CantidadDisponible: this.configService.etiquetas.CantidadDisponible,
      CiudadDireccionEntrega: this.configService.etiquetas.CiudadDireccionEntrega,
      Cliente: this.configService.etiquetas.Cliente,
      Comentario: this.configService.etiquetas.Comentario,
      Compania: this.configService.etiquetas.Compania,
      CPDireccionEntrega: this.configService.etiquetas.CPDireccionEntrega,
      CuentaDistribuidor: this.configService.etiquetas.CuentaDistribuidor,
      CuitCliente: this.configService.etiquetas.CuitCliente,
      DescripcionItemDescuento: this.configService.etiquetas.DescripcionItemDescuento,
      DescuentoCategoria: this.configService.etiquetas.DescuentoCategoria,
      DescuentoDiscrecional: this.configService.etiquetas.DescuentoDiscrecional,
      Direccion: this.configService.etiquetas.PedidosVenta.PV.Direccion,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega,
      Division: this.configService.etiquetas.FilterDivision,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      Glosa: this.configService.etiquetas.Glosa,
      IdGrupoCliente: this.configService.etiquetas.IdGrupoCliente,
      IdMoneda: this.configService.etiquetas.IdMoneda,
      IdProducto: this.configService.etiquetas.IdProducto,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCondicion: this.configService.etiquetas.IdTipoCondicion,
      IdTipoListaPrecios: this.configService.etiquetas.IdTipoListaPrecios,
      Importe: this.configService.etiquetas.Importe,
      Item: this.configService.etiquetas.Item,
      MensajeIntegracion: this.configService.etiquetas.MensajeIntegracion,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreClienteDireccionEntrega: this.configService.etiquetas.NombreClienteDireccionEntrega,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,
      NroLinea: this.configService.etiquetas.NroLinea,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      Path: this.configService.etiquetas.PedidosVenta.PV.Path,
      Porcentaje: this.configService.etiquetas.Porcentaje,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      Region: this.configService.etiquetas.Region,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      TipoEntrega: this.configService.etiquetas.TipoEntrega,
      TipoListaPrecios: this.configService.etiquetas.TipoListaPrecios,
      TipoOrden: this.configService.etiquetas.TipoOrden,
      Titulo: this.configService.etiquetas.PedidosVenta.PV.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalDescuento: this.configService.etiquetas.TotalDescuento,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      TotalPrecioKGL: this.configService.etiquetas.TotalPrecioKGL,
      ZonaVendedor: this.configService.etiquetas.ZonaVendedor

    }

    if (this.ncCab != null) {

      this.ncService.cPedidosRelacionados(this.ncCab.idPais, this.ncCab.idCompania, this.ncCab.idSalesOrg, this.ncCab.idDivision, this.ncCab.nroCliente).subscribe((data: PedidoCabecera[]) => {

        this.dataSource.data = [];
        if (data != null) {
          this.dataSource.data = data;
        }

      });


    }



  }

  seleccionar(p: any) {
    this.dialogRef.close(p);
  }


  clasePorEstado(idTipoOrden: string, id: string) {
    let clase = ClasePorEstado(idTipoOrden, id);
    return clase;
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
